import { CommonModule } from '@angular/common';
import { Component, ChangeDetectionStrategy } from '@angular/core';

/**
 * YouTube's mobile bottom tab bar. The tabs themselves are skeleton
 * placeholders — only the centre "create" button is drawn, because it's the one
 * landmark that makes the bar read as YouTube.
 */
@Component({
    selector: 'app-youtube-mobile-bottom-nav',
    imports: [CommonModule],
    templateUrl: './youtube-mobile-bottom-nav.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './youtube-mobile-bottom-nav.component.scss'
})
export class YoutubeMobileBottomNavComponent {}
